export default "__VITE_ASSET__BjUtb1Uw__"